import { render, staticRenderFns } from "./schoolTwo.vue?vue&type=template&id=5d7faee6&scoped=true"
import script from "./schoolTwo.vue?vue&type=script&lang=js"
export * from "./schoolTwo.vue?vue&type=script&lang=js"
import style0 from "./schoolTwo.vue?vue&type=style&index=0&id=5d7faee6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7faee6",
  null
  
)

export default component.exports